module.exports = __webpack_public_path__ + "static/img/二维动画-MG动画.e6e2420.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10006/二维动画-MG动画.png
// module id = rTJ3
// module chunks = 1